export default {"src":"/_next/static/media/arrow-bottom-icon.d1dbf5c5.svg","height":5,"width":6};